import { render, staticRenderFns } from "./BuyerActivityStatusAction.vue?vue&type=template&id=5123da0c&scoped=true"
import script from "./BuyerActivityStatusAction.vue?vue&type=script&lang=js"
export * from "./BuyerActivityStatusAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123da0c",
  null
  
)

export default component.exports